module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAA4klEQVR4Ae3MIYoCUQCA4V/EIJgME7YY7J7BtjfwBMsk8QpWz2D0BjZPYLK4RQSrwWa0yL/pgYg6b+YNm+Y7wId767DH3DrkiHNTzQURl6ZYSojarq1qbdsQiV23VrG1K48R9j1Y1sG+PEc48GwZZwfyKsKRV2NdHcm7CMfejHFzLJ8inHi3yN2JFEU4s8hMYiJc+MlCYqOWK99Z2YqPsOPGVzZ2pEyEPXc+29mTshFmnnx0MpMqEQ69GFwcStUIpwZTSYlyg7yJmqiJ/iX6qSc6mtURHf2S9Cg0SdG3vzGN/AEdZtdBHj6jkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/m-link_1x.png
// module id = 2304
// module chunks = 0